import { createLabeledMessages } from '../../../messageUtils';
const delegations = {
    enter: 'Enter',
    inDelegations: 'on behalf',
    orInDelegations: 'or on behalf',
    genericError: 'Unexpected error occurred.',
    userHasNoPermissions: "User don't have permission to use the application.",
    cannotDelegate: "You don't have permissions to enter on behalf of {{representativeFor}}. You will be logged as yourself."
};
export default Object.assign({}, delegations, createLabeledMessages(delegations));
